const colors = {
  // --- Paleta Semântica Principal ---
  primary: '#1e3a8a',
  secondary: 'rgb(19, 85, 154)',
  success: '#10b981',
  error: '#ef4444',
  warning: '#f59e0b',
  info: '#3b82f6',

  primaryBlue: '#1e3a8a',
  secondaryBlue: 'rgb(19, 85, 154)',
  oldSecondaryBlue: '#3b82f6',
  grayLight: '#f8fafc',
  grayMedium: '#64748b',
  grayDark: '#334155',
  successGreen: '#10b981',
  errorRed: '#ef4444',
  warningYellow: '#f59e0b',

  // --- Cores de Texto ---
  textPrimary: '#334155',
  textSecondary: '#64748b',
  textLight: '#94a3b8',

  // --- Cores de Fundo ---
  background: '#f8fafc',
  backgroundAlt: '#ffffff',

  // --- Cores de UI (Bordas, Hovers, etc) ---
  border: '#e2e8f0',
  borderLight: '#f1f5f9',
  hoverPrimary: '#1e40af',
  hoverSecondary: '#0f4c75',
  lightBlue: '#dbeafe',
  white: '#ffffff',

  // --- Gradientes ---
  gradientPrimary: 'linear-gradient(135deg, #1e3a8a 0%, rgb(19, 85, 154) 100%)',
  gradientSecondary: 'linear-gradient(135deg, #3b82f6 0%, #1e3a8a 100%)',
  gradientLight: 'linear-gradient(135deg, #dbeafe 0%, #ffffff 100%)',
};

const theme = {
  colors,
  fonts: {
    primary: "'Montserrat', sans-serif",
    weights: { light: 300, regular: 400, medium: 500, semibold: 600, bold: 700 },
  },
  sizes: {
    mobile: '480px', tablet: '768px', desktop: '1024px', largeDesktop: '1200px',
    space: { xs: '4px', sm: '8px', md: '16px', lg: '24px', xl: '32px', xxl: '48px', xxxl: '64px' }, // prettier-ignore
    radius: { sm: '4px', md: '8px', lg: '12px', xl: '16px', xxl: '24px', round: '50%', pill: '9999px' }, // prettier-ignore
    container: { sm: '640px', md: '768px', lg: '1024px', xl: '1280px', xxl: '1536px' },
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    card: '0 8px 25px rgba(0, 0, 0, 0.1)',
    button: '0 8px 25px rgba(59, 130, 246, 0.25)',
    large: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    primary: '0 8px 25px rgba(30, 58, 138, 0.2)',
    secondary: '0 8px 25px rgba(19, 85, 154, 0.2)',
    success: '0 8px 25px rgba(16, 185, 129, 0.2)',
    error: '0 8px 25px rgba(239, 68, 68, 0.2)',
    warning: '0 8px 25px rgba(245, 158, 11, 0.2)',
  },
  transitions: {
    fast: '0.15s ease',
    normal: '0.3s ease', // Usar para botões, inputs, cards, etc.
    slow: '0.5s ease',
  },
  zIndex: { base: 1, dropdown: 10, sticky: 20, modal: 30, popover: 40, tooltip: 50, notification: 60, max: 9999 },
  status: {
    // Referenciando as cores principais para consistência
    active: { background: colors.success, color: colors.white, border: colors.success },
    pending: { background: colors.warning, color: colors.white, border: colors.warning },
    inactive: { background: colors.error, color: colors.white, border: colors.error },
    paid: { background: colors.success, color: colors.white, border: colors.success },
    overdue: { background: colors.error, color: colors.white, border: colors.error },
  },
  layout: { headerHeight: '70px', footerHeight: '60px', sidebarWidth: '280px', containerPadding: '20px', mobilePadding: '15px' },
};

export default theme;
